import React from "react";
import styles from "./creators.module.scss";
import cx from "classnames";

export default function Creators() {
  return (
    <>
      <div className={styles.creators}>
        <div className={styles.creatorsImg}>
          <img
            src="/images/creatorAstronaut.png"
            className={styles.astronaut}
          />
        </div>
        <div className={styles.textSection}>
          <h2 className={styles.heading}>Creators</h2>
          <h4 className={styles.subHeding}>Look who won the space race</h4>

          <section className={styles.creatorsLogo}>
            <div className={styles.logo}>
              <img src="/images/creators/grammerly.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/workspan.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/safesystems.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/servicenow.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/tis.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/cbre.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/fox.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/idb.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/yokohama.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/armada.png" />
            </div>

            <div className={styles.logo}>
              <img src="/images/creators/pathwayacademy.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/harvard.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/times.png" />
            </div>
            <div className={styles.logo}>
              <img src="/images/creators/teachai.png" />
            </div>
          </section>
        </div>
        <div className={styles.creatorsImg}>
          <img src="/images/creatorStone.png" className={styles.stone} />
        </div>
      </div>
    </>
  );
}
